import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { Button } from "../components/Button";
import { FederatedLogins } from "../components/FederatedLogins";
import { Input } from "../components/Input";
import { error, infoWithTimeout } from "../components/Messages";
import { Separator } from "../components/Separator";
import { bemName } from "../util/bemName";
import "./ChangePasswordForm.scss";
import { useProfileContext } from "@/contexts/ProfileContext";
import { signIn, updatePassword } from "aws-amplify/auth";

const componentName = "ChangePasswordForm";

type Props = {
  includeFederated?: boolean;
};

export const ChangePasswordForm = ({ includeFederated }: Props) => {
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>();
  const profile = useProfileContext();
  const navigate = useNavigate();

  // useEffect(
  //     () => {
  //         logger.log("@@@@ profile", profile);
  //     },
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //     []
  // )

  async function handleChangePassword() {
    try {
      const response = await updatePassword({
        oldPassword: password,
        newPassword,
      });
      // navigate("/");
    } catch (err: any) {
      // logger.log("@@@@ error", err);
      error(err.body?.message || err.message);
    }
  }

  const checkError = () => {
    if (password !== "" && (newPassword !== "" || verifyPassword !== "")) {
      if (newPassword !== verifyPassword) {
        return "New passwords do not match";
      }
    }

    return undefined;
  };

  useEffect(
    () => {
      setErrorMessage(checkError());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [password, newPassword, verifyPassword]
  );

  const enableSubmit =
    password !== "" && newPassword !== "" && verifyPassword === newPassword;

  return (
    <div className={bemName(componentName, "container")}>
      <div>
        {includeFederated && (
          <>
            <FederatedLogins prefix="Change password with" />
            <Separator text="or" />
          </>
        )}

        <div className={bemName(componentName, "requestForm")}>
          <div className={bemName(componentName, "input")}>
            <Input
              type="password"
              placeholder="Password"
              value={password}
              autoComplete="current-password"
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          <div className={bemName(componentName, "input")}>
            <Input
              type="password"
              placeholder="New password"
              value={newPassword}
              autoComplete="new-password"
              onChange={(event) => setNewPassword(event.target.value)}
            />
          </div>
          <div className={bemName(componentName, "input")}>
            <Input
              type="password"
              placeholder="New password"
              value={verifyPassword}
              autoComplete="new-password"
              onChange={(event) => setVerifyPassword(event.target.value)}
            />
          </div>
          <div className={bemName(componentName, "actions")}>
            <div className={bemName(componentName, "button")}>
              <Button
                type="submit"
                text="Change Password"
                disabled={!enableSubmit}
                onClick={() => handleChangePassword()}
              />
            </div>
            <div className={bemName(componentName, "links")}>
              <Link to="/login">Cancel</Link>
            </div>
          </div>
          {errorMessage && (
            <div className={bemName(componentName, "message")}>
              {errorMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
